import {useConfig} from '@aboutyou/config';
import {useEffect} from 'react';

export const usePreloadExpressCheckout = () => {
  const {device} = useConfig();

  useEffect(() => {
    // Preload the checkout script for the current device
    // This is a performance optimization to load the checkout script earlier
    if (window.scayleCheckout?.express?.V3) {
      window.scayleCheckout.express.V3.preload(device);
    }
  }, [device]);
};
